var render = function render(){var _vm=this,_c=_vm._self._c;return _c('board-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"boardData":_vm.boardData}})
}
var staticRenderFns = []

export { render, staticRenderFns }